<!--
 * @Description: 
 * @Author: lz
 * @Date: 2021-06-26 16:37:10
 * @LastEditTime: 2021-12-17 17:28:14
 * @LastEditors: wumao
-->
<template>
  <div class="ant-modal-mask">
    <div class="spin">
      <a-spin :tip="text"> </a-spin>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: 'Loading...',
    },
  },
}
</script>
<style lang="less" scoped>
.ant-modal-mask {
  .spin {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
